// extracted by mini-css-extract-plugin
export default {"homeBody":"HomeBody_homeBody__d4fW7","homeBodyEmbedded":"HomeBody_homeBodyEmbedded__3G5x2","colabPend":"HomeBody_colabPend__Xrt9B","colabOk":"HomeBody_colabOk__14DpW"};